import React, { lazy } from "react";
import { ENUM_GAME_TYPE } from "../store/enums";
import PageWitchMenu from "../components/mui/page_witch_menu/PageWitchMenu";
import useScrollUp from "../hooks/useScrollUp";
import ErrorBoundary from "../components/mui/error_boundary/ErrorBoundary";
import LoaderContainer from "../components/mui/loader_container/LoaderContainer";
import { useAppSelector } from "../store/index.ts";
import CusSuspense from "../components/mui/CusSuspense.jsx";
import Banners from "../components/landing/banners/Banners";
import Header from "../components/landing/header/Header.jsx";
import CatalogGame from "../components/landing/catalog_game/CatalogGame";
import useJackpotInterval from "../hooks/common/useJackpotInterval.js";
import "./main.scss";
import useCheckPathname from "../hooks/useCheckPathname.js";
import TypeGamesMenu from "../components/landing/type_games_menu/TypeGamesMenu";
import Jackpot from "../components/landing/jackpot/Jackpot";
import FindGameLine from "../components/landing/find_game_line/FindGameLine";
import Favorites from "../components/landing/favorites/Favorites";

// const LastChampions = lazy(() => import("../components/landing/last_champions/LastChampions"));

const Footer = lazy(() => import("../components/landing/footer/Footer"));

export default function Main() {
  useScrollUp();
  useJackpotInterval();
  useCheckPathname();

  const loader = useAppSelector((state) => state.site.mainLoader);
  const errorInfo = useAppSelector((state) => state.site.errorInfo);

  return (
    <LoaderContainer center loader={loader || errorInfo} fullHeight>
      <PageWitchMenu className={"landing"}>
        <ErrorBoundary>
          <Header />
        </ErrorBoundary>
        {/* <CusSuspense fallback={<div style={{ minHeight: 100 }} className="last-champion"></div>}>
          <LastChampions />
        </CusSuspense> */}
        <ErrorBoundary>
          <Banners />
        </ErrorBoundary>
        <ErrorBoundary>
          <Jackpot />
        </ErrorBoundary>
        <CusSuspense>
          <TypeGamesMenu activeTab={ENUM_GAME_TYPE.lobby} />
        </CusSuspense>
        <CusSuspense>
          <FindGameLine />
        </CusSuspense>
        <ErrorBoundary>
          <CatalogGame />
        </ErrorBoundary>
        <CusSuspense>
          <Favorites />
        </CusSuspense>
        {/* <LatestRates /> */}
        <CusSuspense>
          <Footer />
        </CusSuspense>
      </PageWitchMenu>
    </LoaderContainer>
  );
}
